import checkIfStepIsVisible from "./checkIfStepIsVisible";

const completeStep = { complete: true, title: "summary" };

const getNextActiveStep = (user, lastStep, context, isNextButton) => {
  const { data, survey } = context;

  if (!isNextButton && survey && survey.complete) {
    return completeStep;
  }

  const checkedDependenciesData = data.filter((step, index) => {

    if ((lastStep || lastStep === 0) && lastStep >= index) {
      return false;
    }

    if (step.hidden_question.includes(`role_type_${user['role_type']}`)) {
      return false
    }

    return checkIfStepIsVisible(step, context, false);
  });

  if (!checkedDependenciesData?.length) {
    return completeStep;
  }

  return checkedDependenciesData[0];
};

export default getNextActiveStep;
